// Parse instants before formatting. Never let the browser timezone reinterpret
// a portal label, and never let missing/invalid values become the current time.
const offsets = {
  UTC: '+00:00', GMT: '+00:00', EST: '-05:00', EDT: '-04:00',
  CST: '-06:00', CDT: '-05:00', MST: '-07:00', MDT: '-06:00',
  PST: '-08:00', PDT: '-07:00', AKST: '-09:00', AKDT: '-08:00', HST: '-10:00',
};
const wallFormats = [
  'MM/DD/YYYY h:mm A', 'MM/DD/YYYY HH:mm', 'MM/DD/YYYY h:mm:ss A', 'MM/DD/YYYY HH:mm:ss',
  'M/D/YYYY h:mm A', 'M/D/YYYY H:mm', 'M/D/YYYY h:mm:ss A', 'M/D/YYYY H:mm:ss',
  'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DD h:mm A',
  'DD/MM/YYYY HH:mm', 'D/M/YYYY HH:mm',
  'ddd, MMM D, YYYY [at] h:mm A', 'ddd MMM D, YYYY [at] h:mm A',
  'ddd, MMM D, YYYY h:mm A', 'ddd MMM D, YYYY h:mm A', 'MMM D, YYYY [at] h:mm A',
].reduce((formats, format) => formats.concat(
  format, format.includes(' h:') ? format.replace(' h:', ' hh:') : []
), []);

export const notificationTimeFormat = preferences => (
  String((preferences || {}).userTimeFormat).replace('h', '') === '12' ? 'h:mm A' : 'HH:mm'
);

export const parseNotificationTime = (value, timezone) => {
  if (value === undefined || value === null || value === '') return null;
  const zone = timezone ? (moment.tz.zone(timezone) ? timezone : 'UTC') : null;
  let parsed;
  if (value instanceof Date || typeof value === 'number') {
    parsed = moment.utc(value);
  } else if (typeof value === 'string') {
    const text = value.trim().replace(/\s+/g, ' ');
    const suffix = text.match(/\s+([A-Z]{2,5}|[+-]\d{2}(?::?\d{2})?)$/i);
    if (suffix && !/^(AM|PM)$/i.test(suffix[1])) {
      const body = text.slice(0, -suffix[0].length);
      const abbreviation = suffix[1].toUpperCase();
      const wall = moment.utc(body, wallFormats, true);
      const local = moment.tz(body, wallFormats, true, zone || 'UTC');
      if (!wall.isValid()) return null;
      // Labels generated in the user's zone may have ambiguous abbreviations
      // (CST in Chicago/Shanghai, IST in India). Prefer that zone when it agrees.
      if (zone && local.format('z').toUpperCase() === abbreviation) {
        if (wall.format('YYYY-MM-DD HH:mm:ss') !== local.format('YYYY-MM-DD HH:mm:ss')) return null;
        parsed = local;
      } else {
        const offset = offsets[abbreviation] || (/^[+-]\d{2}(?::?\d{2})?$/.test(abbreviation)
          ? abbreviation + (abbreviation.length === 3 ? ':00' : '') : null);
        if (!offset) return null;
        parsed = moment.parseZone(body + ' ' + offset, wallFormats.map(f => f + ' Z'), true);
      }
    } else if (/^\d{4}-\d{2}-\d{2}T.*(?:Z|[+-]\d{2}:?\d{2})$/i.test(text)) {
      parsed = moment.parseZone(text, moment.ISO_8601, true);
    } else {
      const wall = moment.utc(text, wallFormats, true);
      parsed = moment.tz(text, wallFormats, true, zone || 'UTC');
      // Reject nonexistent wall times during the spring DST transition.
      if (!wall.isValid() || wall.format('YYYY-MM-DD HH:mm:ss') !== parsed.format('YYYY-MM-DD HH:mm:ss')) return null;
    }
  } else return null;
  return parsed.isValid() && parsed.year() > 1 ? (zone ? parsed.tz(zone) : parsed) : null;
};

export const formatNotificationTime = (value, preferences = {}, format) => {
  const parsed = parseNotificationTime(value, preferences.tz);
  return parsed ? parsed.format(format || ('MM/DD/YYYY ' + notificationTimeFormat(preferences) + ' z')) : '';
};
